var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"padding":"20px"}},[_c('van-icon',{attrs:{"name":"scan","size":"60"},on:{"click":_vm.scanAction}})],1),_c('audio',{attrs:{"src":require("../assets/readok.mp3"),"id":"eventAudio"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }